import { UnidadeForcaMuscularSelectModel } from 'view/atendimentos/components/MedicoesPanel/UnidadeForcaMuscularSelectField'

import { MedicaoAnteriorModel } from '../model-medicoes'

export interface MedicaoAnteriorExameFisicoFormModel {
  data: string
  valorForcaMuscMaoDireita?: string
  unidadeForcaMuscMaoDireita?: UnidadeForcaMuscularSelectModel
  valorForcaMuscMaoEsquerda?: string
  unidadeForcaMuscMaoEsquerda?: UnidadeForcaMuscularSelectModel
  error?: string
}

export const MEDICOES_ANTERIORES_EXAME_FISICO: Array<keyof MedicaoAnteriorModel> = [
  'valorForcaMuscMaoDireita',
  'unidadeForcaMuscMaoDireita',
  'valorForcaMuscMaoEsquerda',
  'unidadeForcaMuscMaoEsquerda',
]

export const MODAL_MEDICAO_ANTERIOR_EXAME_FISICO_TAB_URL = '/exameFisico'
